import React from "react";
import { TrendingUp, Crosshair, Shield } from "lucide-react";

const OPS = [
  {
    key: "growth-ops",
    icon: TrendingUp,
    title: "Growth Operations",
    items: [
      "Content Amplification",
      "Audience Expansion",
      "Visibility Campaigns",
      "Strategic Positioning",
    ],
  },
  {
    key: "intelligence-ops",
    icon: Crosshair,
    title: "Intelligence Operations",
    items: [
      "Due Diligence",
      "Strategic Research",
      "Verification Services",
      "Business Intelligence",
    ],
  },
  {
    key: "protection-ops",
    icon: Shield,
    title: "Protection Operations",
    items: [
      "Crisis Response",
      "Reputation Management",
      "Digital Risk Assessment",
      "Threat Mitigation",
    ],
  },
];

export const OnDemand = () => {
  return (
    <section
      id="operations"
      data-testid="ondemand-section"
      className="relative bg-black text-white py-24 md:py-32 lg:py-40 border-t border-zinc-900 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 relative">
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="h-px w-10 bg-zinc-600" />
            <span className="font-mono text-[10px] md:text-xs tracking-[0.4em] uppercase text-zinc-400">
              On-Demand
            </span>
            <span className="h-px w-10 bg-zinc-600" />
          </div>
          <h2 className="font-display font-light uppercase leading-[1] tracking-tight text-4xl sm:text-5xl md:text-6xl">
            Specialized Operations
          </h2>
          <p className="mt-8 font-sans text-base md:text-lg text-zinc-400 leading-relaxed">
            Members can request specialized operations whenever required.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-zinc-900">
          {OPS.map(({ key, icon: Icon, title, items }) => (
            <article
              key={key}
              data-testid={`ondemand-card-${key}`}
              className="bg-black p-8 md:p-10 hover:bg-zinc-950 transition-colors duration-500 min-h-[380px] flex flex-col"
            >
              <div className="flex items-center gap-4 mb-8 pb-6 border-b border-zinc-900">
                <Icon size={24} strokeWidth={1} className="text-white" />
                <h3 className="font-display font-light text-2xl md:text-3xl uppercase tracking-tight">
                  {title}
                </h3>
              </div>
              <ul className="space-y-4 flex-1">
                {items.map((it) => (
                  <li
                    key={it}
                    className="flex items-center gap-3 font-mono text-[11px] tracking-[0.2em] uppercase text-zinc-300"
                  >
                    <span className="h-px w-4 bg-zinc-600" />
                    {it}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="font-mono text-[10px] md:text-xs tracking-[0.4em] uppercase text-zinc-500">
            Pricing varies depending on operational scope and requirements
          </p>
        </div>
      </div>
    </section>
  );
};

export default OnDemand;
